module.exports = __webpack_public_path__ + "static/media/SRPF47_02.24016f4d.png";